import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { PreloadAllModules, RouterModule, Routes } from '@angular/router'
const routes: Routes = [
  {
    path: 'datos-personales',
    loadChildren: () => import('./home/home.module').then((m) => m.HomeModule),
  },
  {
    path: 'steps',
    loadChildren: () =>
      import('./steps/steps.module').then((m) => m.StepsModule),
  },
  { path: '**', pathMatch: 'full', redirectTo: 'datos-personales' },
]

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      useHash: true,
      scrollPositionRestoration: 'enabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
